// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Mv5g","colBig":"styles_colBig__STHNu","colSmall":"styles_colSmall__1Orfy"};